/**
 * Started to move all our axios call here into a single wrapper.
 * This should help with the testing stubs a lot.
 */

import axios from "axios";
import * as Sentry from "@sentry/react";

import { UserEventsAPI } from "./userEventsAPI";
import { getLocationsUrl } from "../store";
import { getZip } from "../Components/Locations/selectors";
import { urlConfig } from "./utils";

let API = {
  /**
   * Query locations based on the zip code saved in state and return received data.
   */
  findLocations: () => async (dispatch, getState) => {
    const state = getState();
    const zip = getZip(state);
    const url = getLocationsUrl(state);
    const response = await axios.post(
      url,
      { zip },
      {
        headers: { "X-CHECKSUM": UserEventsAPI._calcHash({ zip }) },
      }
    );
    return response.data.data;
  },

  /**
   * Send lead info again.
   */
  resubmitLead: () => async (dispatch, getState) => {
    const state = getState();
    const { leadID } = state;
    const data = { leadID };

    if (state.config.apiResendLeadEmailURL) {
      await axios.post(state.config.apiResendLeadEmailURL, data, {
        headers: { "X-CHECKSUM": UserEventsAPI._calcHash(data) },
      });
    }
  },

  _send: async (url, data) => {
    try {
      return await axios.post(url, data, {
        headers: { "X-CHECKSUM": UserEventsAPI._calcHash(data) },
      });
    } catch (response) {
      Sentry.withScope(function (scope) {
        Sentry.captureException(response);
      });
    }
  },

  /**
   * Send chat start request.
   */
  startChat: (data) => async (dispatch, getState) => {
    const state = getState();
    return API._send(state.config.apiChatStartURL, data);
  },
};

/**
 * Lol the API class is definitely gonna help with testing stubs but it is still ugly as hell for selenium tests
 * which runs in a separate process and cant really use Jest stubbing features.
 * At this point - we'll have to create more and more urlConfig keys
 * or to assign some stubs via `window.FamilyAssetsChat` handle.
 */
if (urlConfig.staticConfig) {
  API = {
    ...API,

    findLocations: () => async () => {
      return [
        {
          address: "1731 W Medical Center Dr, Anaheim, CA 92801",
          image_url:
            "https://g5-assets-cld-res.cloudinary.com/image/upload/q_auto,f_auto,fl_lossy/g5/g5-c-ilk08ojc-maplewood-senior-living-client/g5-cl-55zk892pn-maplewood-healthcare/uploads/featured_props-brewster.jpg",
          name: "Emerald Court",
          phone: "(714) 778-5100",
          url: "https://www.kiscoseniorliving.com/senior-living/ca/anaheim/emerald-court/",
        },
        {
          address: "2860 Country Dr, Fremont, CA ",
          image_url:
            "https://g5-assets-cld-res.cloudinary.com/image/upload/q_auto,f_auto,fl_lossy/g5/g5-c-ilk08ojc-maplewood-senior-living-client/g5-cl-55zk892pn-maplewood-healthcare/uploads/featured_props-brewster.jpg",
          name: "Fremont Retirement Community",
          phone: "510 790 1654",
          url:
            "https://www.happylivingbycogir.com/en/residential-building-fremont/12-fremont-retirement-community.html",
        },
      ];
    },
  };
}

export default API;
